export const ALZA_BASE_PATH = '/'
export const SMARCEL_BASE_PATH = '/london-nova2026'
